// extracted by mini-css-extract-plugin
export var subtitle = "_9q-2";
export var title = "_9q-0";
export var titleNoWrap = "_9q-1";